<template>
  <div class="mt8 mb8">
    <cx-check-box :value.sync="showLegend" :isDisabled="legendDisabled">显示图例</cx-check-box>
    <div v-if="showLegend" class="mt12">
      <div class="paddingl19 verticallyTop">
        <p class="font14 mr16">排列</p>
        <el-radio-group v-model="legendOrient" class="flex1">
          <el-radio class="mb8" v-for="(item, index) in legendOrientList" :key="index" :label="item.label"
            >{{ item.title }}
          </el-radio>
        </el-radio-group>
      </div>
      <collapsibleItem>
        <div slot="heading">布局</div>
        <div slot="body" class="bar-color-sets mt8">
          <cx-select
            class="mb16"
            title="位置"
            @change="legendPositionChange"
            :selectOptions="legendPositionList"
            :value="legendPosition"
            selectLabel="title"
            selectValue="item"
          />
          <p class="font14 mb8">间距</p>
          <slider-and-input
            class="mb16"
            inputWidth="small"
            inputHeight="small"
            :value.sync="legendItemGap"
            title=""
            titlePosition="singleLine"
            suffix="px"
          />
          <div class="content-item">
            <cx-padding
              :paddingTypeFlag.sync="legendIconPaddingTypeFlag"
              :padding.sync="legendPadding"
              :paddingTop.sync="legendPaddingTopLeft"
              :paddingRight.sync="legendPaddingTopRight"
              :paddingBottom.sync="legendPaddingBottomRight"
              :paddingLeft.sync="legendPaddingBottomLeft"
            />
          </div>
        </div>
      </collapsibleItem>
      <collapsibleItem>
        <div slot="heading">文字</div>
        <div slot="body" class="bar-color-sets mt8">
          <!-- 字体和颜色/字重和字号 -->
          <text-setting-update
            class=""
            colorMode="chart"
            :fontColor.sync="legendFontColor"
            :fontFamily.sync="legendFontFamily"
            :fontSize.sync="legendFontSize"
            :fontWeight.sync="legendFontWeight"
          />
        </div>
      </collapsibleItem>
      <collapsibleItem>
        <div slot="heading">图标</div>
        <div slot="body" class="bar-color-sets">
          <div class="mb12">
            <span class="font14 mr16 inlineMiddle">类型</span>
            <el-radio-group v-model="legendIconColor">
              <el-radio value="default" label="default">实心</el-radio>
              <el-radio value="custom" label="custom">空心</el-radio>
            </el-radio-group>
          </div>
          <div class="mb12">
            <cx-select
              class="mb16"
              title="形状"
              @change="legendIconChange"
              :selectOptions="legendIcons"
              :value="legendIcon"
              selectLabel="title"
              selectValue="value"
            />
          </div>
          <double-input
            class=""
            title="尺寸"
            placeHolderText="必填"
            :value1.sync="legendItemWidth"
            :value2.sync="legendItemHeight"
            :inputSuffixs="iconSizeSuffix"
          />
        </div>
      </collapsibleItem>
    </div>
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      legendPositionList: [
        {
          title: "顶部居中",
          horizontal: "center",
          vertical: "top",
          value: 0
        },
        {
          title: "顶部居左",
          horizontal: "left",
          vertical: "top",
          value: 1
        },
        {
          title: "顶部居右",
          horizontal: "right",
          vertical: "top",
          value: 2
        },
        {
          title: "底部居中",
          horizontal: "center",
          vertical: "bottom",
          value: 3
        },
        {
          title: "底部居左",
          horizontal: "left",
          vertical: "bottom",
          value: 4
        },
        {
          title: "底部居右",
          horizontal: "right",
          vertical: "bottom",
          value: 5
        },
        {
          title: "左侧居中",
          horizontal: "left",
          vertical: "middle",
          value: 6
        },
        {
          title: "右侧居中",
          horizontal: "right",
          vertical: "middle",
          value: 7
        }
      ],
      this1: this,
      iconSizeSuffix: ["宽", "高"],
      legendIcons: [
        {
          value: "",
          title: "默认"
        },
        {
          value: "circle",
          title: "圆形"
        },
        {
          value: "rect",
          title: "直角矩形"
        },
        {
          value: "roundRect",
          title: "圆角矩形"
        },
        {
          value: "triangle",
          title: "三角形"
        },
        {
          value: "diamond",
          title: "菱形"
        },
        {
          value: "pin",
          title: "气球"
        },
        {
          value: "arrow",
          title: "箭头"
        }
      ],
      legendArrangeList: [
        {
          title: "横向排列",
          label: "horizontal"
        },
        {
          title: "纵向排列",
          label: "vertical"
        }
      ],
      legendIconPaddingTypeFlag: 1
    }
  },
  mounted() {
    this.padding = this.options.chartOption.legend.padding
    this.$nextTick(() => {
      if (!this.padding) return
      if (
        this.padding[0] === this.padding[1] &&
        this.padding[0] === this.padding[2] &&
        this.padding[0] === this.padding[3]
      ) {
        this.legendIconPaddingTypeFlag = 1
      } else {
        this.legendIconPaddingTypeFlag = 2
      }
    })
  },
  methods: {
    legendPositionChange(value) {
      this.legendTop = value.vertical
      this.legendLeft = value.horizontal
    },
    changeLegendIconPaddingType(value) {
      this.legendIconPaddingTypeFlag = value
    },
    // 处理水滴和箭头不能和文字水平对齐的问题
    setIconTextAlign() {
      let rich = {}
      if (this.legendIcon === "arrow") {
        rich = {
          a: {
            padding: [this.legendItemHeight, 0, 0, 0],
            fontSize: this.legendFontSize
          }
        }
      } else if (this.legendIcon === "pin") {
        rich = {
          a: {
            padding: [0, 0, this.legendItemHeight, 0],
            fontSize: this.legendFontSize
          }
        }
      }
      this.$changeOptionsEV(rich, "chartOption.legend.textStyle.rich", false)
    },
    legendIconChange(value) {
      this.legendIcon = value
    }
  },
  computed: {
    legendPosition() {
      for (let i = 0; i < this.legendPositionList.length; i++) {
        if (
          this.legendPositionList[i].horizontal === this.legendLeft &&
          this.legendPositionList[i].vertical === this.legendTop
        ) {
          return this.legendPositionList[i].title
        }
      }
      return "顶部居左"
    },
    chartType() {
      return this.options.chartOption.series[0].type
    },
    legendDisabled() {
      //  柱状图多色的时候不显示图例
      let isMultiColor = false
      for (let i = 0; i < this.options.chartOption.series.length; i++) {
        if (
          this.options.chartOption.series[i].type === "bar" &&
          this.options.chartOption.series[i].data[0].itemStyle.color
        ) {
          isMultiColor = true
          break
        }
      }
      return isMultiColor
    },
    showLegend: {
      get() {
        return this.checkAndSetPrimaryVal(this.options.chartOption.legend, "show", "show", true)
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.show = newVal
        params.legend.defaultShow = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendTop: {
      get() {
        return this.options.chartOption.legend.top
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.top = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendLeft: {
      get() {
        return this.options.chartOption.legend.left
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.left = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendIcon: {
      get() {
        if (this.options.chartOption.legend.hasOwnProperty("icon")) {
          return this.options.chartOption.legend.icon
        } else {
          return ""
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.legend.icon", false)
        this.$changeOptionsEV("{a|{name}}", "chartOption.legend.formatter", false)
        this.setIconTextAlign()
        //  如果后期拓展为图表的图例使用多种图标的时候可以用下列代码稍加修改
        // let thisData = this.options.chartOption.legend.data
        // if (typeof thisData === "undefined") {
        //   let val = []
        //   switch (this.chartType) {
        //     case "bar":
        //       this.seriesData.forEach((item, index) => {
        //         val.push({
        //           name: item.name,
        //           icon: newVal
        //         })
        //       })
        //       this.$changeOptionsEV(val, "chartOption.legend.data", false)
        //       break
        //     case "line":
        //       this.seriesData.forEach((item, index) => {
        //         val.push({
        //           name: item.name,
        //           icon: newVal
        //         })
        //       })
        //       this.$changeOptionsEV(val, "chartOption.legend.data", false)
        //       break
        //     case "pie":
        //       this.seriesData[0].data.forEach((item, index) => {
        //         val.push({
        //           name: item.name,
        //           icon: newVal
        //         })
        //       })
        //       this.$changeOptionsEV(val, "chartOption.legend.data", false)
        //       break
        //     default:
        //   }
        //
        //   this.$changeOptionsEV(newVal, "chartOption.legend.icon", false)
        //   return
        // }
        // for (let i = 0; i < this.options.chartOption.legend.data.length; i++) {
        //   if (typeof this.options.chartOption.legend.data[i] === "object") {
        //     this.$changeOptionsEV(newVal, "chartOption.legend.data." + i + ".icon", false)
        //   } else {
        //     let curVal = {
        //       name: this.options.chartOption.legend.data[i],
        //       icon: newVal
        //     }
        //     this.$changeOptionsEV(curVal, "chartOption.legend.data." + i, false)
        //   }
        // }
      }
    },
    legendItemWidth: {
      get() {
        return Number(this.options.chartOption.legend.itemWidth) || 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.legend.itemWidth", false)
      }
    },
    legendItemHeight: {
      get() {
        return Number(this.options.chartOption.legend.itemHeight) || 14
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.legend.itemHeight", false)
        this.$changeOptionsEV(newVal, "chartOption.legend.textStyle.lineHeight", false)
        this.setIconTextAlign()
      }
    },
    legendItemGap: {
      get() {
        return Number(this.options.chartOption.legend.itemGap) || 10
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.legend.itemGap", false)
      }
    },
    legendPaddingTopLeft: {
      get() {
        let padding = this.options.chartOption.legend.padding
        return typeof padding !== "undefined" ? (Array.isArray(padding) ? padding[0] : padding) : 0
      },
      set(newVal) {
        if (Array.isArray(this.options.chartOption.legend.padding)) {
          this.$changeOptionsEV(newVal, "chartOption.legend.padding.0", false)
        } else {
          this.$changeOptionsEV(
            [newVal, this.legendPaddingTopRight, this.legendPaddingBottomRight, this.legendPaddingBottomLeft],
            "chartOption.legend.padding",
            false
          )
        }
      }
    },
    legendPaddingTopRight: {
      get() {
        let padding = this.options.chartOption.legend.padding
        return typeof padding !== "undefined"
          ? Array.isArray(padding)
            ? padding.length > 1
              ? padding[1]
              : padding[0]
            : padding
          : 0
      },
      set(newVal) {
        if (Array.isArray(this.options.chartOption.legend.padding)) {
          this.$changeOptionsEV(newVal, "chartOption.legend.padding.1", false)
        } else {
          this.$changeOptionsEV(
            [this.legendPaddingTopLeft, newVal, this.legendPaddingBottomRight, this.legendPaddingBottomLeft],
            "chartOption.legend.padding",
            false
          )
        }
      }
    },
    legendPaddingBottomRight: {
      get() {
        let padding = this.options.chartOption.legend.padding
        return typeof padding !== "undefined"
          ? Array.isArray(padding)
            ? padding.length > 1
              ? padding[2]
              : padding[0]
            : padding
          : 0
      },
      set(newVal) {
        if (Array.isArray(this.options.chartOption.legend.padding)) {
          this.$changeOptionsEV(newVal, "chartOption.legend.padding.2", false)
        } else {
          this.$changeOptionsEV(
            [this.legendPaddingTopLeft, this.legendPaddingTopRight, newVal, this.legendPaddingBottomLeft],
            "chartOption.legend.padding",
            false
          )
        }
      }
    },
    legendPaddingBottomLeft: {
      get() {
        let padding = this.options.chartOption.legend.padding
        return typeof padding !== "undefined"
          ? Array.isArray(padding)
            ? padding.length > 1
              ? padding[3]
              : padding[0]
            : padding
          : 0
      },
      set(newVal) {
        if (Array.isArray(this.options.chartOption.legend.padding)) {
          this.$changeOptionsEV(newVal, "chartOption.legend.padding.3", false)
        } else {
          this.$changeOptionsEV(
            [this.legendPaddingTopLeft, this.legendPaddingTopRight, this.legendPaddingBottomRight, newVal],
            "chartOption.legend.padding",
            false
          )
        }
      }
    },
    // legendIconPaddingTypeFlag: {
    //   get() {
    //     if (
    //       !Array.isArray(this.padding) ||
    //       (this.padding[0] === this.padding[1] &&
    //         this.padding[0] === this.padding[2] &&
    //         this.padding[0] === this.padding[3])
    //     ) {
    //       this.legendIconPaddingTypeFlag = 2
    //     } else {
    //       this.legendIconPaddingTypeFlag = 1
    //     }
    //   },
    //   set() {}
    // },
    legendPadding: {
      get() {
        let padding = this.options.chartOption.legend.padding
        return typeof padding !== "undefined" ? (Array.isArray(padding) ? padding[0] : padding) : 0
      },
      set(newVal) {
        newVal = parseInt(newVal)
        let val = [newVal, newVal, newVal, newVal]
        this.$changeOptionsEV(val, "chartOption.legend.padding", false)
      }
    },
    legendFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "chartOption.legend.textStyle.fontFamily", "legendFontFamily", "sans-serif")
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.textStyle.fontFamily = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendFontColor: {
      get() {
        return this.options.chartOption.legend.textStyle.color
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.textStyle.color = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendFontWeight: {
      get() {
        return this.options.chartOption.legend.textStyle.fontWeight
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.textStyle.fontWeight = newVal
        this.$changeOptionsEV(params, "chartOption", false)
      }
    },
    legendFontSize: {
      get() {
        return this.options.chartOption.legend.textStyle.fontSize
      },
      set(newVal) {
        let params = { ...this.options.chartOption }
        params.legend.textStyle.fontSize = newVal
        this.$changeOptionsEV(params, "chartOption", false)
        this.setIconTextAlign()
      }
    },
    legendIconColor: {
      get() {
        let legendData = this.options.chartOption.legend.data
        return typeof legendData !== "undefined" &&
          legendData.length > 0 &&
          legendData[0].hasOwnProperty("itemStyle") &&
          legendData[0].itemStyle.hasOwnProperty("color") &&
          legendData[0].itemStyle.color === "transparent"
          ? "custom"
          : "default"
      },
      set(newVal) {
        let legendData = this.options.chartOption.legend.data
        if (newVal === "custom") {
          let newData = []
          let series = this.options.chartOption.series
          if (series[0].type === "pie" || series[0].type === "radar") {
            series = series[0].data
          }
          series.forEach((item, index) => {
            let oldItemStyle = legendData
              ? typeof legendData[index] === "object"
                ? { ...legendData[index] }
                : { name: legendData[index] }
              : { name: item.name }
            let itemStyle = {
              ...oldItemStyle,
              itemStyle: {
                color: "transparent",
                borderWidth: 2,
                borderColor: series[index].type === "line" ? item.lineStyle.color : item.itemStyle.color
              }
            }
            newData.push(itemStyle)
          })
          this.$changeOptionsEV(newData, "chartOption.legend.data", false)
        } else {
          if (typeof legendData !== "undefined") {
            legendData.forEach((data, index) => {
              delete data.itemStyle
              this.$changeOptionsEV(data, "chartOption.legend.data." + index, false)
            })
          }
        }
      }
    },
    // 动态数据
    seriesData: {
      get() {
        if (this.options.chartOption.series) {
          return this.options.chartOption.series
        }
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption", false)
      }
    },
    disabledLegend() {
      let disabledLegend = this.chartType === "bar" && this.seriesData[0].data[0].itemStyle.color ? true : false
      this.showLegend = disabledLegend ? false : this.showLegend
      return disabledLegend
    },
    legendOrient: {
      get() {
        return this.options.chartOption.legend.orient || "horizontal"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.legend.orient", false)
      }
    }
  }
}
</script>

<style scoped>
.width-44 {
  width: calc(100% - 44px);
}
.paddingl19 {
  padding-left: 19px;
  box-sizing: border-box;
}
.el-radio {
  margin-right: 20px;
}
.el-radio:nth-child(2n) {
  margin-right: 0;
}
</style>
